import { ajax } from "lib/observable";
import { Observable } from "rxjs";
import "rxjs/add/operator/map";
import { PAYMENTS_MANAGEMENT } from "constants/action-types";
import siteConfig from "site-config";
import { updateEntities } from "redux-query";
import * as qs from "qs";
import { getRecordsFromSchema, normalizeData } from "lib/api";
import { Statements as StatementsSchema } from "schemas/payments";
import { FileExport as FileExportSchema } from "schemas/files";
import * as moment from "moment";
import { push } from "react-router-redux";

export const fetchStatementsEpic = (action$, store) =>
    action$.ofType(PAYMENTS_MANAGEMENT.STATEMENTS.FETCH.START).mergeMap(({ payload }) => {
        const { scope } = store.getState();
        const { currencyCode, year } = payload;
        const account = scope.brand.modules.payments.accounts.find((account) => {
            return (
                account.currency_code === currencyCode && ["done", "pending", "active"].includes(account.detail.status)
            );
        });

        // asking for all the statements for a year is really asking for December of previous year up until November of current year
        const query = {
            start_date_gte: moment.utc(`1/1/${year}`, ["MM/DD/YYYY"]).startOf("month").valueOf(),
            start_date_lte: moment.utc(`12/1/${year}`, ["MM/DD/YYYY"]).endOf("month").valueOf(),
            __sort: "start_date",
            __sort_order: "desc",
        };
        return ajax(`${siteConfig.api}/api/v3.0/statements/account/${account._id}?${qs.stringify(query)}`)
            .flatMap(({ response, status, xhr }) => {
                const records = getRecordsFromSchema(StatementsSchema);
                const data = normalizeData(response, StatementsSchema, records);

                return [
                    updateEntities({
                        statements: (current) => {
                            return {
                                ...current,
                                ...data.entities.statement,
                            };
                        },
                    }),
                    {
                        payload: data.result,
                        type: PAYMENTS_MANAGEMENT.STATEMENTS.FETCH.COMPLETED,
                    },
                ];
            })
            .catch((error) => {
                const actions = [];

                if (error.status === 401 || error.status === 403) {
                    actions.push(Observable.of(push("/403")));
                }

                return Observable.merge(
                    ...actions,
                    Observable.of({
                        error: true,
                        payload: error,
                        type: PAYMENTS_MANAGEMENT.STATEMENTS.FETCH.COMPLETED,
                    }),
                );
            });
    });

export const createStatementsEpic = (action$, store) =>
    action$.ofType(PAYMENTS_MANAGEMENT.STATEMENTS.CREATE.START).mergeMap(({ payload }) => {
        const { scope } = store.getState();
        const { id, display_name, file_type, format } = payload;

        return ajax({
            method: "POST",
            body: {
                format,
                file_type,
                options: {
                    statement_id: id,
                    display_name,
                },
            },
            url: `${siteConfig.api}/api/v3.0/files/export`,
        })
            .flatMap(({ response, status, xhr }) => {
                const records = getRecordsFromSchema(FileExportSchema);
                const data = normalizeData(response, FileExportSchema, records);

                return [
                    updateEntities({
                        fileExports: (current) => {
                            return {
                                ...current,
                                ...data.entities.fileExports,
                            };
                        },
                    }),
                    {
                        payload: [],
                        error: false,
                        type: PAYMENTS_MANAGEMENT.STATEMENTS.CREATE.COMPLETED,
                    },
                    () => window.open(`/brand/${scope.brand._id}/payment-statement/${data.result}/download`, "_newtab"),
                ];
            })
            .catch((error) => {
                return Observable.merge(
                    Observable.of({
                        error: true,
                        payload: error,
                        type: PAYMENTS_MANAGEMENT.STATEMENTS.CREATE.COMPLETED,
                    }),
                );
            });
    });
